import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
  const { user, hasToken } = useSelector((state) => state.user);

  if (!user && hasToken) {
    return <></>;
  }

  return user ? children : <Navigate to='/login' replace />;
};
export default PrivateRoute;
